// extracted by mini-css-extract-plugin
module.exports = {"component":"ModuleContent_component__18Lox","pageContent":"ModuleContent_pageContent__2A3x4"};